 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"notfound":"notfound","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","survey":"survey","survey-courtyard":"survey-courtyard","survey-entrance":"survey-entrance","survey-exit":"survey-exit","survey-free-comment":"survey-free-comment","survey-how-old-age":"survey-how-old-age","survey-how-old-by-age":"survey-how-old-by-age","survey-reading-distortions":"survey-reading-distortions","survey-reading-fatigue":"survey-reading-fatigue","survey-reading-flickering":"survey-reading-flickering","survey-reading-like":"survey-reading-like","survey-reading-line-tracking":"survey-reading-line-tracking","survey-reading-skips":"survey-reading-skips","survey-reading-speed":"survey-reading-speed","survey-reading-state":"survey-reading-state","survey-reading-volume":"survey-reading-volume","survey-what-gender":"survey-what-gender","survey-where-live-province":"survey-where-live-province","survey-where-live-region":"survey-where-live-region","survey-which-font":"survey-which-font","survey-which-font-compare-fonts":"survey-which-font-compare-fonts","survey-which-layout":"survey-which-layout","survey-writing-care":"survey-writing-care","survey-writing-letter-like":"survey-writing-letter-like","survey-writing-sentence-like":"survey-writing-sentence-like","survey-writing-speed":"survey-writing-speed"}[chunkId]||chunkId) + "." + {"chunk-181d2b20":"b9bcf6ae","chunk-2d0abfcf":"8417852b","chunk-2d0b6524":"83036341","chunk-2d0b722b":"ddbb227b","chunk-2d0ba1c2":"0ea94410","chunk-2d0bad0a":"c62fafa7","chunk-2d0cfe34":"c2e5cf3d","chunk-2d0dd0bc":"b5c4bb06","chunk-2d0e51f2":"a9f59e76","chunk-2d0e538f":"30d81b24","chunk-2d208de0":"04efcebb","chunk-2d2091ed":"0fe22200","chunk-2d21d0c2":"92f1ac93","chunk-2d228cf2":"2eb22644","chunk-2d22c8e3":"74407e83","chunk-2d22c8fe":"51558486","chunk-2d23154f":"8621d2da","chunk-3153b88e":"506cb877","chunk-33995bb4":"32fda13c","chunk-35d3c3ea":"cd375f12","chunk-394e349e":"6e4f0dff","chunk-394e93ea":"a15254a9","chunk-492dfdba":"a2d40a6d","chunk-51470c54":"1aa3d6e9","chunk-2d0e6487":"eed135a3","chunk-2d2105ef":"dbb6f922","chunk-2d226365":"bd731769","chunk-522a38c6":"ec2c25c8","chunk-5578f2bd":"cd8e88fb","chunk-58be091e":"416c52cb","chunk-60df2cf2":"a362876a","chunk-6b4304ff":"53a14e32","chunk-a2d59590":"0aa551e2","chunk-b60c65e2":"dcea3b7d","chunk-d688bb3a":"459321a5","chunk-e5e547a4":"16131496","chunk-f6a011f0":"3d68857c","chunk-f993edd8":"d87498c4","notfound":"140bf230","polyfills-core-js":"c802f76e","polyfills-css-shim":"ac087954","polyfills-dom":"e01853a0","survey":"73527fc7","survey-courtyard":"2ae1b726","survey-entrance":"1647061b","survey-exit":"8702ef68","survey-free-comment":"5eecc8a4","survey-how-old-age":"35d2e4c8","survey-how-old-by-age":"4d9c17f6","survey-reading-distortions":"305155d3","survey-reading-fatigue":"9b01099c","survey-reading-flickering":"f42a3598","survey-reading-like":"bf2a6a29","survey-reading-line-tracking":"65f123c7","survey-reading-skips":"e0c363bb","survey-reading-speed":"c68286f0","survey-reading-state":"d53d3d0e","survey-reading-volume":"3d046cfa","survey-what-gender":"fd4eb15a","survey-where-live-province":"e78b533f","survey-where-live-region":"5937e82e","survey-which-font":"2896ca0e","survey-which-font-compare-fonts":"e399d762","survey-which-layout":"dfae6ce8","survey-writing-care":"f51bdd4f","survey-writing-letter-like":"5d094bf5","survey-writing-sentence-like":"7cac809e","survey-writing-speed":"58003b69"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([4,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
